export type MenuItemType = {
  copy: string;
  to?: string;
  onClick?:  () => void;
  type?: string;
  variant?: 'nav' | 'cta' | 'cta-outlined';
  condition?: boolean;
  subItems?: MenuItemType[];
};

interface MenuContent {
  pages: MenuItemType[];
  settings: MenuItemType[];
}

export const createMenuItems = (
    isLoggedIn: boolean,
    onLogout: () => void,
    onHome: () => void,
    onSetNewHome: () => void,
    onSearch: () => void
): MenuContent => ({
    pages: ([
        {
            copy: 'About',
            to: '/about',
            variant: 'nav' as const,
        },
        {
            copy: 'Contact Us',
            to: '/contact-us',
            variant: 'nav' as const,
        },
        {
            copy: 'Search',
            onClick: onSearch,
            variant: 'nav' as const,
        },
        isLoggedIn
            ? {
                copy: 'Fly Home',
                onClick: onHome,
                variant: 'nav' as const,
            }
            : null,
        {
            copy: 'Sign Up',
            to: '/sign-up',
            variant: 'cta' as const,
            condition: !isLoggedIn,
        },
        {
            copy: 'Sign In',
            to: '/sign-in',
            variant: 'cta-outlined' as const,
            condition: !isLoggedIn,
        },
    ] as (MenuItemType | null)[]).filter((e): e is MenuItemType => e !== null),
    settings: isLoggedIn
        ? [
            {
                copy: 'Set new home',
                onClick: onSetNewHome,
            },
            {
                copy: 'Edit profile',
                to: '/edit-profile',
            },
            {
                copy: 'Sign Out',
                type: 'button',
                onClick: onLogout,
            },
        ]
        : [],
});
